module.exports = __webpack_public_path__ + "static/img/testIcon2.59eb9f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testIcon2.png
// module id = iFmK
// module chunks = 1